// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsLife = {
  benefits_section_life: {
    contentful_name: '[DEFAULT] Benefits Section - Life',
    basic_benefit_limit: '基本保障限额',
    basic_benefit_amount: '基本福利金额',
    eligible_pay: '符合条件的工资',
    salary: '薪资',
    benefit_is_multiple_of_salary: '员工{salaryOrEP}的{multiple}倍',
    supplemental_benefit_amount: '{suppTerm}福利金额',
    supplemental_benefit_limit: '{suppTerm}福利限额',
    supplemental: '补充',
    optional: '可选',
    voluntary: '自愿',
    eoi_header: '可保性证明',
    eoi_body: '注册后,您可能需要回答一些关于家族病史的问题,以获得全额保障的批准。详情请查看您的计划文件。',
    dependent_coverage_header: '受抚养人保障',
    dependent_coverage_body:
      '您也可以为您的受抚养人购买人寿保险。这通常与您的个人保险运作方式相同,但您可以为受抚养人购买的保额可能会根据您自己的选择而有所不同。有关保障范围和费率的完整详情,请参阅您的福利文件。',
  },
};
